import React, { useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';
import Loading from '../../components/Loading/Loading';

//Api
import cep_api from '../../api/cep_api';
import destinacaoColeta_api from '../../api/destinacaoColeta_api';
//Helpers
import mascaras from '../../helpers/mascaras';
import { validarCampos, objCampo, PrintValidate } from '../../helpers/ValidadorDeCampos';
import { showMessage } from '../../helpers/message';

//Estado inicial da entrada avulsa
function initialStateEntradaAvulsa() {
    return {
        id: "0",
        placa: "",
        dataInclusao: "",
        fantasia: "",
        razao: "",
        logradouro: "",
        numero: "",
        bairro: "",
        cidade: "",
        uf: "",
        responsavel: "",
        cep: "",
        cnpj: "",
        tbTipoColeta_Id: "",
        pesoEntrada: "0,00",
    }
}
export default function EntradaAvulsa({ btnVoltar }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);
    //Estado que guarda os dados do formulario
    const [entradaAvulsa, setEntradaAvulsa] = useState(initialStateEntradaAvulsa);
    //Estado que guarda todas as opções de modalidades de coleta disponiveis para o veiculo a partir do destino logado
    const [modalidades, setModalidades] = useState([{ text: "Selecione", value: "" }]);
    //Estado de controle dos campos de erros
    const [errors, setErrors] = useState({});
    //Campos para validação dos campos obrigatorios
    const campos = [
        objCampo({ name: "placa", required: true, placa: true }),
        objCampo({ name: "fantasia", required: true }),
        objCampo({ name: "logradouro", required: true }),
        objCampo({ name: "numero", required: true }),
        objCampo({ name: "bairro", required: true }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "uf", required: true }),
        objCampo({ name: "responsavel", required: true }),
        objCampo({ name: "cep", required: true }),
        objCampo({ name: "cnpj", required: true, cnpj: true }),
        objCampo({ name: "tbTipoColeta_Id", required: true }),
        objCampo({ name: "pesoEntrada", required: true, number: true }),
    ]
    //OnChange para os campos do formulario
    const onChange = (e) => {
        const { name, value } = e.target;

        const _entradaAvulsa = {
            ...entradaAvulsa,
            [name]: value
        };
        const campo = campos.filter(value => value.name === name);
        const _errors = validarCampos(_entradaAvulsa, campo);
        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            const novosErrors = { ...errors };
            delete novosErrors[name];
            setErrors({ ...novosErrors });
        }
        setEntradaAvulsa(_entradaAvulsa)
    }
    //OnBlur para o campo de cep do endereço
    const onBlurCep = (e) => {
        const { name, value } = e.target;
        const _entradaAvulsa = {
            ...entradaAvulsa,
            [name]: value
        }
        _entradaAvulsa.cep = mascaras.cepMask(_entradaAvulsa.cep, true);
        if (_entradaAvulsa.cep.length == 8) {
            setLoading(true);
            cep_api.get(_entradaAvulsa.cep).then(response => {
                if (response.data.erro) {
                    showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
                    return;
                }
                _entradaAvulsa.bairro = response.data.bairro;
                _entradaAvulsa.uf = response.data.uf;
                _entradaAvulsa.complemento = response.data.complemento;
                _entradaAvulsa.logradouro = response.data.logradouro;
                _entradaAvulsa.cidade = response.data.localidade;
                const erros = validarCampos(_entradaAvulsa, campos);
                setErrors(erros[0]);
                const endereco = {
                    NumeroCep: _entradaAvulsa.cep,
                    Bairro: _entradaAvulsa.bairro,
                    Logradouro: _entradaAvulsa.logradouro,
                    Cidade: _entradaAvulsa.cidade,
                    Estado: _entradaAvulsa.estado,
                    Numero: _entradaAvulsa.numero,
                }
                setEntradaAvulsa(_entradaAvulsa);
            }).catch(e => {
                showMessage("Aviso", "CEP não encontrado na base de dados", "error", null);
            }).finally(f => setLoading(false));
        }
    }
    //OnBlur para o campo de placa
    const onBlurPlaca = (e) => {
        const { name, value } = e.target;
        if (value.length != 8) {
            return;
        }
        destinacaoColeta_api.GetVeiculoSemRegistro(value).then(response => {
            if (response.data) {
                const _errors = validarCampos(response.data, campos);
                setErrors(_errors[0]);
                setEntradaAvulsa({ ...response.data });
            }
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
    }
    //OnSubmit da entrada avulsa
    const onSubmit = () => {
        const _errors = validarCampos(entradaAvulsa, campos);
        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        const _entradaAvulsa = { ...entradaAvulsa };
        _entradaAvulsa.pesoEntrada = parseFloat(_entradaAvulsa.pesoEntrada.replace(",", "."));
        destinacaoColeta_api.InsertEntradaAvulsa(_entradaAvulsa).then(response => {
            showMessage("Sucesso", "Entrada avulsa cadastrada com sucesso", "success", btnVoltar);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        });
    }
    //Carrega as modalidades possiveis para o destino
    const loadModalidades = () => {
        destinacaoColeta_api.GetModalidades().then(response => {
            response.data = response.data.map(value => {
                return {
                    value: value.id,
                    text: value.descricao
                }
            })
            setModalidades([{ text: "Selecione", value: "" }, ...response.data])
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        })
    }
    useEffect(() => {
        loadModalidades();
    }, []);
    return (
        <MainCard btnVoltarInTop={btnVoltar} title={<>Entrada Avulsa</>}>
            {loading && <Loading />}
            <Row className='mb-4'>
                <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
            </Row>
            <Row>
                <Col md="4">
                    <TextField mask={mascaras.placaMask} maxLength={"8"} label="* Veículo" name="placa" value={entradaAvulsa.placa} onChange={onChange} onBlur={onBlurPlaca} invalid={errors.placa ? true : false} />
                    <PrintValidate field={"placa"} errors={errors} />
                </Col>
                <Col md="4">
                    <TextField mask={mascaras.cnpjMask} maxLength={"18"} label="* CNPJ" name="cnpj" value={entradaAvulsa.cnpj} onChange={onChange} invalid={errors.cnpj ? true : false} />
                    <PrintValidate field={"cnpj"} errors={errors} />
                </Col>
                <Col md="4">
                    <TextField label="* Fantasia" name="fantasia" value={entradaAvulsa.fantasia} onChange={onChange} invalid={errors.fantasia ? true : false} />
                    <PrintValidate field={"fantasia"} errors={errors} />
                </Col>
                <Col md="4">
                    <TextField mask={mascaras.cepMask} label="* CEP" name="cep" value={entradaAvulsa.cep} onChange={onChange} onBlur={onBlurCep} invalid={errors.cep ? true : false} />
                    <PrintValidate field={"cep"} errors={errors} />
                </Col>
                <Col md="4">
                    <TextField label="* Cidade" name="cidade" value={entradaAvulsa.cidade} onChange={onChange} invalid={errors.cidade ? true : false} />
                    <PrintValidate field={"cidade"} errors={errors} />
                </Col>


                <Col md="4">
                    <TextField label="* Bairro" name="bairro" value={entradaAvulsa.bairro} onChange={onChange} invalid={errors.bairro ? true : false} />
                    <PrintValidate field={"bairro"} errors={errors} />
                </Col>
                <Col md="8">
                    <TextField label="* Logradouro" name="logradouro" value={entradaAvulsa.logradouro} onChange={onChange} invalid={errors.logradouro ? true : false} />
                    <PrintValidate field={"logradouro"} errors={errors} />
                </Col>
                <Col md="2">
                    <TextField mask={mascaras.numeroMask} label="* Numero" name="numero" value={entradaAvulsa.numero} onChange={onChange} invalid={errors.numero ? true : false} />
                    <PrintValidate field={"numero"} errors={errors} />
                </Col>
                <Col md="2">
                    <TextField label="* Estado" name="uf" value={entradaAvulsa.uf} onChange={onChange} invalid={errors.uf ? true : false} />
                    <PrintValidate field={"uf"} errors={errors} />
                </Col>
                <Col md="12">
                    <TextField label="* Responsavel" name="responsavel" value={entradaAvulsa.responsavel} onChange={onChange} invalid={errors.responsavel ? true : false} />
                    <PrintValidate field={"responsavel"} errors={errors} />
                </Col>
                <Col md="6">
                    <TextField label="* Modalidade de coleta" name="tbTipoColeta_Id" value={entradaAvulsa.tbTipoColeta_Id} type={"select"} options={modalidades} onChange={onChange} invalid={errors.tbTipoColeta_Id ? true : false} />
                    <PrintValidate field={"tbTipoColeta_Id"} errors={errors} />
                </Col>
                <Col md="6">
                    <TextField mask={mascaras.floatMask} label="* Peso de entrada" name="pesoEntrada" value={entradaAvulsa.pesoEntrada} onChange={onChange} invalid={errors.pesoEntrada ? true : false} />
                    <PrintValidate field={"pesoEntrada"} errors={errors} />
                </Col>
            </Row>
            <div className="d-flex align-items-center justify-content-center">
                <Button color='success bg-gradient' onClick={onSubmit}>+ Adicionar</Button>
            </div>
        </MainCard>
    )

}